import React from 'react';
import './Modal.css';

// Modal genérico de confirmação (exclusão, descarte de alterações, etc.).
// Substitui os window.confirm() nativos por um popup no mesmo padrão visual do painel admin.
const ModalConfirm = ({
  isOpen,
  onClose,
  onConfirm,
  message = 'Confirmar a exclusão?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar'
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-card blue-theme">
        <button className="btn-close-modal" onClick={onClose}>&times;</button>

        <p className="modal-message">{message}</p>

        <div className="modal-actions">
          <button className="btn-modal-action" onClick={onClose}>{cancelLabel}</button>
          <button className="btn-modal-action" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm;
